import React from "react";
import WrapperIonInput from '../../ionic/WrapperIonInput';
import {useTranslation} from 'react-i18next';

const InputField = (props) => {
    const {t, i18n} = useTranslation();

    const description = props.schema.description || props.uiSchema['ui:description'];
    return <>
        <WrapperIonInput
            label={`${t(props.schema.title)} ${(props.schema.title && props.required) ? ' *' : ''}`}
            required={props.required}
            disabled={props.disabled}
            value={props.formData}
            Change={props.onChange}
        />
        {/* <small>
            {description}
        </small> */}
    </>;
};

export default InputField;
